<template>
  <v-dialog v-model="dialog" max-width="400px" scrollable>
    <v-card>
      <v-card-title>Atendimento Online</v-card-title>
      <v-divider></v-divider>

      <v-card-text class="mb-4">
        <v-row class="my-6">
          <v-col class="text-center">
            <v-avatar size="70px" color="#EDEAFC">
              <app-icon size="40px" color="primary">videocam</app-icon>
            </v-avatar>
            <div class="mt-4">
              <h4>{{ session.customer.name }}</h4>
            </div>
            <div class="mt-2">
              <template v-if="session.video_call_link">
                <span class="text--secondary">{{ callLink }}</span>
              </template>
              <template v-else>
                <span class="text--secondary">
                  Video Chamada do Psicoplanner
                </span>
              </template>
            </div>

          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn @click="handleOpenVideoCall()" block color="primary">
              <app-icon class="mr-2">video_call</app-icon>
              Iniciar
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="session.customer.phone_wa">
          <v-col>
            <v-btn @click="handleSendLinkToWhatsapp()" :disabled="linkSent" outlined block color="primary">
              <v-icon class="mr-2">mdi-whatsapp</v-icon>
              {{ linkSentText }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="shareLinkSupported">
          <v-col>
            <v-btn @click="handleShareLink()" outlined block color="primary">
              <app-icon class="mr-2">share</app-icon>
              Compartilhar Link
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="clipboardSupported">
          <v-col>
            <v-btn @click="handleCopyLink()" outlined block color="primary">
              <app-icon class="mr-2">content_copy</app-icon>
              Copiar Link
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <app-back-btn @click="dialog = false" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      shareLinkSupported: null,
      session: {
        customer: {},
      },
      linkSent: false,
    };
  },
  created() {
    this.shareLinkSupported = "share" in navigator;
  },

  computed: {
    linkSentText() {
      return this.linkSent === true
        ? "Notificação enviada"
        : "Enviar link por WhatsApp";
    },
    clipboardSupported() {
      return navigator.clipboard;
    },

    isCustomLink() {
      return this.session.video_call_link !== null;
    },

    callLink() {
      if (this.isCustomLink) {
        return this.session.video_call_link;
      }

      return "https://meu.psicoplanner.com.br/api/videochamada";
    },

    professionalCallLink() {
      if (!this.isCustomLink) {
        return `${this.callLink}/profissional/${this.session.id}/${this.session.uuid}`;
      }
      return this.callLink;
    },
    customerCallLink() {
      if (!this.isCustomLink) {
        return `${this.callLink}/${this.session.id}/${this.session.uuid}`;
      }
      return this.callLink;
    },
  },

  methods: {
    open(session) {
      this.session = JSON.parse(JSON.stringify(session));

      if (!this.session.customer_id) {
        this.session.customer = {
          name: this.session.booking.name,
          phone_wa: this.session.booking.phone_wa
        }
      }
      this.dialog = true;
      this.linkSent = false;
    },

    handleOpenVideoCall() {
      window.open(this.professionalCallLink, "_blank");
    },

    handleSendLinkToWhatsapp() {
      // this.$loading.start();
      // this.$http
      //   .$post("sessions/send-link-video-call", {
      //     session_id: this.session.id,
      //   })
      //   .then((response) => {
      //     this.$snackbar({
      //       message: "Notificação  por WhatsApp enviada !",
      //       color: "success",
      //       timeout: 1000,
      //       showClose: false,
      //     });
      //     this.linkSent = true;
      //     this.$loading.finish();
      //   })
      //   .catch((error) => {
      //     this.$loading.finish();
      //   });


      let mensagem = `Olá ${this.session.customer.name}`;
      mensagem += `, você foi convidado(a) para uma video chamada.`
      mensagem += `\n\n`
      mensagem += `*Orientações:*`
      mensagem += `\n1º - Escolha um local tranquilo e silencioso.`
      mensagem += `\n2º - Tenha uma boa iluminação.`
      mensagem += `\n3º - Certifique-se que a bateria do seu celular esteja carregada.`
      mensagem += `\n4º - Recomendamos que seu aparelho esteja conectado a uma rede Wi-Fi.`
      mensagem += `\n\n`
      mensagem += `Clique no link abaixo para participar.`
      mensagem += `\n${this.customerCallLink}`

      let phone = this.session.customer.phone_wa.replace(/\D/g, '');
      let link = `https://api.whatsapp.com/send?phone=+${phone}`;
      let msg = `&text=${encodeURIComponent(mensagem)}`;



      window.open(link + msg);
    },

    handleShareLink() {
      navigator.share({
        title: "Compartilhar Link",
        text: "Compartilhar Link",
        url: this.customerCallLink,
      });
    },

    handleCopyLink() {
      navigator.clipboard
        .writeText(this.customerCallLink)
        .then((response) => {
          this.$snackbar({
            message: "Link copiado com sucesso!",
            color: "success",
            timeout: 1000,
            showClose: false,
          });
        })
        .catch((error) => { });
    },
  },
};
</script>

<style></style>
